// removed by extract-text-webpack-plugin
module.exports = {"chatText":"styles__chatText___1lRol","placeholderText":"styles__placeholderText___2i403","grey":"styles__grey___20O-Q","blackBack":"styles__blackBack___3wm14","black":"styles__black___2y-pa","_input":"styles___input___o8yje","_inputWrap":"styles___inputWrap___3C0Ak","_inputWrap-42":"styles___inputWrap-42___3hSu8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBar/styles.scss
// module id = 7024
// module chunks = 0